// extracted by mini-css-extract-plugin
export default {"navigation":"Navbar_navigation__F8EBq","links":"Navbar_links__paxU1"};